import sa from 'sa-sdk-javascript';
import { getQueryString } from './index'

// 点击文本框
export function ClientClickTextView (title, place, name, phone, length, flag) {
    sa.track('ClientClickTextView', {
        platform_type: 'zl_wap',
        entrance_pageview_name: document.URL,
        entrance_pageview_title: title,
        entrance_position_name: place,
        input_content: name,
        input_phone_number: phone,
        make_appointments: flag,
        textview_focus_state: true,
        text_length: length,
        is_participant: getQueryString('id') === '000'
    });
}

// 元素点击
export function ClientClickContent (btn) {
    sa.track('ClientClickContent', {
        platform_type: 'zl_wap',
        pageview_title: document.title,
        element_content: btn,
        pageview_address: document.URL
    });
}

// 资产配置计算
export function ClientCalcAssetAllocation (valArr) {
    sa.track('ClientCalcAssetAllocation', {
        platform_type: 'zl_wap',
        SSE_enterprise_bond: valArr[0],
        crude: valArr[1],
        golden: valArr[2],
        sp500: valArr[3],
        shanghai_shenzhen_300: valArr[4],
        zhong_zheng_500: valArr[5]
    });
}

// 完成计算
export function ClientFinishCalcAssetAllocation (valArr) {
    sa.track('ClientFinishCalcAssetAllocation', {
        platform_type: 'zl_wap',
        sharpe_ratio: valArr[0],
        annualized_return: valArr[1],
        maximum_withdrawal: valArr[2],
        investment_style: valArr[3],
        accumulative_profit: valArr[4],
        configuration_amount: valArr[5],
        is_participant: getQueryString('id') === '000'
    });
}
